/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProductVariantCreateRequest {
  cean?: string;
  cfop?: string;
  costPrice?: number;
  cst?: string;
  defaultImageURL?: string;
  displayOrder?: number;
  expirationAttribute?: string;
  externalId?: number;
  externalStoreUrl?: string;
  extipi?: string;
  genero?: string;
  internalEAN?: string;
  invoiceName?: string;
  invoicePrice?: number;
  isSellableUrl?: boolean;
  isTradeable?: boolean;
  longExternalStoreUrl?: string;
  maxTradesPerPerson?: number;
  ncm?: string;
  productId?: number;
  productVariantName?: string;
  salePrice?: number;
  tradeActive?: boolean;
  tradePoints?: number;
  unitMeasure?: number;
  unitName?: string;
  weight?: number;
  wmsId?: number;
}
